export default __webpack_public_path__ + "static/solstice-e34852ad5c4e1e89e564c01c13c0650a.png";